var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/extenders/details-expand.js
var DetailsExpand = class extends HTMLElement {
  constructor() {
    var _a;
    super();
    __publicField(this, "toggleContent", () => {
      const currentState = this.clickableElement.getAttribute("aria-expanded");
      const dropdownElement = document.querySelector(`#${this.filterId}`) || this.querySelector("#dropdownList");
      if (currentState === "true") {
        this.clickableElement.setAttribute("aria-expanded", "false");
        if (dropdownElement) {
          dropdownElement.style.height = "0px";
        }
      } else {
        this.clickableElement.setAttribute("aria-expanded", "true");
        if (this.dropdownListElement) {
          dropdownElement.style.height = dropdownElement.style.maxHeight;
        }
      }
    });
    const detailsExpandElement = this;
    this.clickableElement = detailsExpandElement.querySelector("[aria-controls]");
    this.filterId = detailsExpandElement.getAttribute("data-filter-id");
    this.clickableElement.addEventListener("click", this.toggleContent, true, { passive: false });
    this.dropdownListElement = detailsExpandElement.querySelector(`#${this.filterId}`) || detailsExpandElement.querySelector("#dropdownList");
    this.shouldBeOpen = (_a = this.dropdownListElement) == null ? void 0 : _a.getAttribute("data-open");
    if (this.dropdownListElement && this.shouldBeOpen === "false") {
      this.dropdownListElement.style.height = "0px";
    }
  }
};
if (customElements.get("details-expand") === void 0) {
  customElements.define("details-expand", DetailsExpand);
}
